<div class="failure-container">
  <div *ngIf="isLoading" class="spinner-grow text-primary" role="status" class=".loader">
    <span class="sr-only">Loading...</span>
  </div>
  <div *ngIf="!isLoading" class="failure-content">
    <div class="failure-icon">
      <i class="material-icons">error</i>
    </div>
    <h1>Error en el Pago</h1>
    <p>{{ errorMessage }}</p>

    <div class="action-buttons">
      <button class="btn-retry" (click)="retryPayment()" aria-label="Intentar realizar el pago nuevamente">
        Intentar nuevamente
      </button>
      <button class="btn-home" (click)="goToHome()" aria-label="Volver a la página de inicio">
        Volver al inicio
      </button>
    </div>
  </div>
</div>